import './App.css';
import { Routes, Route, Link } from "react-router-dom";
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Parties from './pages/Parties/Parties';
import MemberProfile from './pages/MemberProfile/MemberProfile';
import Methodology from './pages/About/Methodology';
import Footer from './components/Footer/Footer';
import Projects from './pages/Projects/Projects';
import { useEffect, useState } from 'react';
import { baseUrl } from "./Config";

function App() {

    const [parties, setParties] = useState([]);
    const [members, setMembers] = useState([]);
    const [projects, setProjects] = useState([]);
    const [links, setLinks] = useState({
        'iale_partido_politico': '#',
        'votacion_del_proyecto': '#',
        'afinidad_libertad': '#',
        'preguntas_frecuentes': '#',
        'para_conocer': '#',
    });

    useEffect(() => {
        fetchLinks();
    }, []);

    const openSearchModal = () => {
        const votersModal = new bootstrap.Modal(document.getElementById('searchModal')); // eslint-disable-line
        votersModal.show();
    };

    const closeSearchModal = () => {
        const votersModal = new bootstrap.Modal(document.getElementById('searchModal')); // eslint-disable-line
        votersModal.hide();
    }

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const fetchLinks = () => {
        fetch(`${baseUrl}/api/v1/links`)
        .then(response => {
            return response.json()
        })
        .then(data => {
            setLinks(data.data);
        })
        .catch(error => {
            console.error('Error fetching links:', error);
            setLinks({
                'iale_partido_politico': '#',
                'votacion_del_proyecto': '#',
                'afinidad_libertad': '#',
                'preguntas_frecuentes': '#',
                'para_conocer': '#',
            });
        })
    }

    const handleSearch = debounce((keyword) => {
        if (keyword != '') {
            fetch(`${baseUrl}/api/v1/search?search=${keyword}`)
            .then(res => res.json())
            .then(data => {
                setParties(data?.data?.parties);
                setMembers(data?.data?.members);
                setProjects(data?.data?.projects);
            });
        } else {
            setParties([]);
            setMembers([]);
            setProjects([]);
        }
    }, 300);

    return (
        <div>
            {/* Navbar */}
            <nav className="navbar navbar-expand-lg fixed-top">
                <div className="container-fluid">
                    <Link className="navbar-brand" to={`/`}>
                        <img src="./assets/images/icp-logo-trans.png" alt="ICP Logo" />
                    </Link>

                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <img src="./assets/images/menu.png" />
                    </button>

                    <div className="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <Link to={`#`} onClick={(e) => {
                                    e.preventDefault();
                                    openSearchModal();
                                }} className="nav-link">
                                    <img src="./assets/images/search-black.svg" />
                                </Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" id="comencemos" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Indicador ▾
                                </a>
                                <ul className="dropdown-menu dropdown-menu-light" aria-labelledby="comencemos">
                                    <li><a className="dropdown-item" href={'./#seating'}>Congresistas</a></li>
                                    <li><Link className="dropdown-item" to={`./projects`}>Normatividad</Link></li>
                                </ul>
                            </li>
                            {/* <li className="nav-item">
                                <Link to={`#`} className="nav-link">Indicador</Link>
                            </li> */}
                            <li className="nav-item">
                                <Link to={`/methodology`} className="nav-link">Metodología</Link>
                            </li>
                            <li className='nav-item'>
                                <Link target="_blank" to={links.preguntas_frecuentes} className='nav-link'>Preguntas Frecuentes</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* Content */}
            <Routes>
                <Route path="/" exact element={<Home/>} />
                <Route path="/about" exact element={<About/>} />
                <Route path="/methodology" exact element={<Methodology/>} />
                <Route path="/parties/:origin/:id" exact element={<Parties/>} />
                <Route path="/parties/:origin" exact element={<Parties/>} />
                <Route path="/member-profile/:member/project/:id/:tab" exact element={<MemberProfile/>} />
                <Route path="/member-profile/:member/project/:id" exact element={<MemberProfile/>} />
                <Route path="/projects" exact element={<Projects/>} />
            </Routes>

            {/* Footer */}
            <Footer />

            {/* Bootstrap Centered Modal */}
            <div className="modal fade" id="searchModal" style={{zIndex: 9999999}} tabIndex="-1" aria-labelledby="searchModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchModalLabel">Buscador IALE</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="container">
                                <div className="search-box">
                                    <img src="./assets/images/search-normal.svg" />
                                    <input type="text" placeholder="Enter Keyword Here" onChange={(e) => {
                                        handleSearch(e.target.value);
                                    }}/>
                                </div>

                                <p className="search-results-title">Resultados de búsqueda:</p>

                                <div className="results">
                                    <div className="category">
                                        <p className="category-title">Partidos Políticos</p>

                                        <div className='d-flex flex-column'>
                                            { parties?.map(party => (
                                                <a key={party.id} href={`/parties/${party.origin_id == 1 ? 'senado' : 'camara'}/${party.id}`} onClick={(e) => {
                                                    closeSearchModal();
                                                }} className="result">{party.name} ({party.origin_id === 1 ? 'Senado' : 'Cámara'})</a>
                                            ))}
                                        </div>

                                        { parties?.length === 0 && (
                                            <p className="no-results">Sin resultados</p>
                                        )}
                                    </div>
                                    <div className="category">
                                        <p className="category-title">Normativa</p>
                                        
                                        <div className='d-flex flex-column'>
                                            { projects?.map(project => (
                                                <a key={project.id} href={`/member-profile/448/project/${project.id}/normatividad`} onClick={closeSearchModal} className="result">{project.name}</a>
                                            ))}
                                        </div>

                                        { projects?.length === 0 && (
                                            <p className="no-results">Sin resultados</p>
                                        )}
                                    </div>
                                    <div className="category">
                                        <p className="category-title">Congresistas</p>
                                        
                                        <div className='d-flex flex-column'>
                                            { members?.map(member => (
                                                <a key={member.id} href={`/parties/${member.party.origin_id == 1 ? 'senado' : 'camara'}/${member.party_id}?member=${member.id}`} onClick={closeSearchModal} className="result">{member.name}</a>
                                            ))}
                                        </div>

                                        { members?.length === 0 && (
                                            <p className="no-results">Sin resultados</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
